import { render, staticRenderFns } from "./KaskoCalculator.vue?vue&type=template&id=024c937e"
import script from "./KaskoCalculator.vue?vue&type=script&lang=ts"
export * from "./KaskoCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports